module.exports = __webpack_public_path__ + "static/media/download-icon.289f1cdc.svg";